var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.hasBanId)?_c('p',[_vm._v("\n    ban id unknown\n  ")]):_vm._e(),(_vm.hasBanId)?_c('player-ban-link',{attrs:{"playerId":_vm.action.playerId,"banId":_vm.action.banId,"lable":"ban"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }